import { PLANT_LIMIT_NOTE } from "../../utils/Chloromance/constants";
import { ChloromanceTier, TrackerSummary } from "../../utils/Chloromance/types";
import { formatPlantLocation } from "../../utils/Chloromance/utils/plants";

type SummaryBarProps = {
  wiltPower: number;
  plantCount: number;
  activeTier: ChloromanceTier;
  summary: TrackerSummary;
};

export function SummaryBar({ wiltPower, plantCount, activeTier, summary }: SummaryBarProps) {
  const isUnlimited = activeTier.plantLimit === null;
  const plantLimitLabel = isUnlimited ? String(plantCount) : `${plantCount}/${activeTier.plantLimit}`;
  const tierNote = activeTier.id === 'free'
    ? PLANT_LIMIT_NOTE
    : isUnlimited
      ? `${activeTier.name} tier: unlimited plants.`
      : `${activeTier.name} tier: ${plantLimitLabel} plants.`;

  return (
    <section className="summary-bar" aria-label="Plant hydration summary">
      <article className="wiltpower-card"><span>Current WiltPower</span><strong>{wiltPower}%</strong></article>
      <article className="plant-limit-card">
        <span>Total Plants</span>
        <strong>{plantLimitLabel}</strong>
        <small>{tierNote}</small>
      </article>
      <article><span>Thirsty</span><strong>{summary.Thirsty}</strong></article>
      <article><span>Critical</span><strong>{summary.Critical}</strong></article>
      <article className="zone-health">
        <span>Location Health</span>
        <div>
          {Object.entries(summary.byZone).map(([zone, zoneSummary]) => (
            <b key={zone}>
              {formatPlantLocation(zone)}: {zoneSummary.total - zoneSummary.thirsty - zoneSummary.critical}/{zoneSummary.total} OK
            </b>
          ))}
        </div>
      </article>
    </section>
  );
}
